import { AxiosInstance } from 'axios'

export default function connect(api: AxiosInstance) {
    return {
        async alreadyKycByUid(uid: string) {
            // eslint-disable-next-line no-param-reassign
            api.defaults.baseURL = process.env.THUNDER_CONNECT_API_V2 || ''
            const result = await api.get('/line-kyc', { params: { uid } })
            return result.data?.status
        },
    }
}
